import { Injectable } from '@angular/core';
import { Trip } from '@models';
import { CrudService } from '../crud/crud.service';
import { HttpService } from '../http/http.service';

@Injectable({
  providedIn: 'root',
})
export class TripService extends CrudService<Trip> {
  constructor(http: HttpService) {
    super('trip', http);
  }

  // override methods which are not available for this service
  override create(data: Partial<Trip>): Promise<Trip> {
    throw new Error('Method not available.');
  }
  override get(): Promise<Trip[]> {
    throw new Error('Method not available.');
  }

  override update(data: Partial<Trip>): Promise<Trip> {
    throw new Error('Method not available.');
  }
  override delete(id: string): Promise<string> {
    throw new Error('Method not available.');
  }
}
